import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import type { StatusContainerId } from "../dnd";
import { StatusItem, type StatusItemBaseProps } from "./status-item";

type Props = StatusItemBaseProps & { container: StatusContainerId };

export const SortableStatusItem = ({ container, ...props }: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: props.status.code,
    data: { container },
  });

  return (
    <StatusItem
      ref={setNodeRef}
      style={{ transform: CSS.Translate.toString(transform), transition }}
      isDragging={isDragging}
      {...attributes}
      {...listeners}
      {...props}
    />
  );
};
